import { render, staticRenderFns } from "./SetNickName.vue?vue&type=template&id=17e6888d&scoped=true&"
import script from "./SetNickName.vue?vue&type=script&lang=js&"
export * from "./SetNickName.vue?vue&type=script&lang=js&"
import style0 from "./SetNickName.vue?vue&type=style&index=0&id=17e6888d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e6888d",
  null
  
)

export default component.exports